import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults, validateParameters } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\PdfExportController::generatePdf
* @see app/Http/Controllers/PdfExportController.php:55
* @route '//app.finesthub.de/export/{template}/pdf'
*/
export const generatePdf = (args: { template: string | number } | [template: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: generatePdf.url(args, options),
    method: 'get',
})

generatePdf.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/export/{template}/pdf',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PdfExportController::generatePdf
* @see app/Http/Controllers/PdfExportController.php:55
* @route '//app.finesthub.de/export/{template}/pdf'
*/
generatePdf.url = (args: { template: string | number } | [template: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { template: args }
    }

    if (Array.isArray(args)) {
        args = {
            template: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template: args.template,
    }

    return generatePdf.definition.url
            .replace('{template}', parsedArgs.template.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PdfExportController::generatePdf
* @see app/Http/Controllers/PdfExportController.php:55
* @route '//app.finesthub.de/export/{template}/pdf'
*/
generatePdf.get = (args: { template: string | number } | [template: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: generatePdf.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PdfExportController::generatePdf
* @see app/Http/Controllers/PdfExportController.php:55
* @route '//app.finesthub.de/export/{template}/pdf'
*/
generatePdf.head = (args: { template: string | number } | [template: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: generatePdf.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PdfExportController::previewPdf
* @see app/Http/Controllers/PdfExportController.php:69
* @route '//app.finesthub.de/export/{template}/preview'
*/
export const previewPdf = (args: { template: string | number } | [template: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: previewPdf.url(args, options),
    method: 'get',
})

previewPdf.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/export/{template}/preview',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PdfExportController::previewPdf
* @see app/Http/Controllers/PdfExportController.php:69
* @route '//app.finesthub.de/export/{template}/preview'
*/
previewPdf.url = (args: { template: string | number } | [template: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { template: args }
    }

    if (Array.isArray(args)) {
        args = {
            template: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        template: args.template,
    }

    return previewPdf.definition.url
            .replace('{template}', parsedArgs.template.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PdfExportController::previewPdf
* @see app/Http/Controllers/PdfExportController.php:69
* @route '//app.finesthub.de/export/{template}/preview'
*/
previewPdf.get = (args: { template: string | number } | [template: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: previewPdf.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PdfExportController::previewPdf
* @see app/Http/Controllers/PdfExportController.php:69
* @route '//app.finesthub.de/export/{template}/preview'
*/
previewPdf.head = (args: { template: string | number } | [template: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: previewPdf.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PdfExportController::generateTemplate
* @see app/Http/Controllers/PdfExportController.php:81
* @route '/pdf-export/{user}/{template}/{id?}'
*/
export const generateTemplate = (args: { user: string | number | { id: string | number }, template: string | number, id?: string | number } | [user: string | number | { id: string | number }, template: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: generateTemplate.url(args, options),
    method: 'get',
})

generateTemplate.definition = {
    methods: ["get","head"],
    url: '/pdf-export/{user}/{template}/{id?}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PdfExportController::generateTemplate
* @see app/Http/Controllers/PdfExportController.php:81
* @route '/pdf-export/{user}/{template}/{id?}'
*/
generateTemplate.url = (args: { user: string | number | { id: string | number }, template: string | number, id?: string | number } | [user: string | number | { id: string | number }, template: string | number, id: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            user: args[0],
            template: args[1],
            id: args[2],
        }
    }

    args = applyUrlDefaults(args)

    validateParameters(args, [
        "id",
    ])

    const parsedArgs = {
        user: typeof args.user === 'object'
        ? args.user.id
        : args.user,
        template: args.template,
        id: args.id,
    }

    return generateTemplate.definition.url
            .replace('{user}', parsedArgs.user.toString())
            .replace('{template}', parsedArgs.template.toString())
            .replace('{id?}', parsedArgs.id?.toString() ?? '')
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PdfExportController::generateTemplate
* @see app/Http/Controllers/PdfExportController.php:81
* @route '/pdf-export/{user}/{template}/{id?}'
*/
generateTemplate.get = (args: { user: string | number | { id: string | number }, template: string | number, id?: string | number } | [user: string | number | { id: string | number }, template: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: generateTemplate.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PdfExportController::generateTemplate
* @see app/Http/Controllers/PdfExportController.php:81
* @route '/pdf-export/{user}/{template}/{id?}'
*/
generateTemplate.head = (args: { user: string | number | { id: string | number }, template: string | number, id?: string | number } | [user: string | number | { id: string | number }, template: string | number, id: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: generateTemplate.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PdfExportController::generateBlankSelfDisclosureTemplate
* @see app/Http/Controllers/PdfExportController.php:39
* @route '/pdf-self-disclosure-template/{applicantCount}'
*/
export const generateBlankSelfDisclosureTemplate = (args: { applicantCount: string | number } | [applicantCount: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: generateBlankSelfDisclosureTemplate.url(args, options),
    method: 'get',
})

generateBlankSelfDisclosureTemplate.definition = {
    methods: ["get","head"],
    url: '/pdf-self-disclosure-template/{applicantCount}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PdfExportController::generateBlankSelfDisclosureTemplate
* @see app/Http/Controllers/PdfExportController.php:39
* @route '/pdf-self-disclosure-template/{applicantCount}'
*/
generateBlankSelfDisclosureTemplate.url = (args: { applicantCount: string | number } | [applicantCount: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { applicantCount: args }
    }

    if (Array.isArray(args)) {
        args = {
            applicantCount: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        applicantCount: args.applicantCount,
    }

    return generateBlankSelfDisclosureTemplate.definition.url
            .replace('{applicantCount}', parsedArgs.applicantCount.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PdfExportController::generateBlankSelfDisclosureTemplate
* @see app/Http/Controllers/PdfExportController.php:39
* @route '/pdf-self-disclosure-template/{applicantCount}'
*/
generateBlankSelfDisclosureTemplate.get = (args: { applicantCount: string | number } | [applicantCount: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: generateBlankSelfDisclosureTemplate.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PdfExportController::generateBlankSelfDisclosureTemplate
* @see app/Http/Controllers/PdfExportController.php:39
* @route '/pdf-self-disclosure-template/{applicantCount}'
*/
generateBlankSelfDisclosureTemplate.head = (args: { applicantCount: string | number } | [applicantCount: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: generateBlankSelfDisclosureTemplate.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PdfExportController::downloadBlankSelfDisclosureTemplate
* @see app/Http/Controllers/PdfExportController.php:27
* @route '//admin.finesthub.test/templates/self-disclosure/{applicantCount}'
*/
export const downloadBlankSelfDisclosureTemplate = (args: { applicantCount: string | number } | [applicantCount: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: downloadBlankSelfDisclosureTemplate.url(args, options),
    method: 'get',
})

downloadBlankSelfDisclosureTemplate.definition = {
    methods: ["get","head"],
    url: '//admin.finesthub.test/templates/self-disclosure/{applicantCount}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PdfExportController::downloadBlankSelfDisclosureTemplate
* @see app/Http/Controllers/PdfExportController.php:27
* @route '//admin.finesthub.test/templates/self-disclosure/{applicantCount}'
*/
downloadBlankSelfDisclosureTemplate.url = (args: { applicantCount: string | number } | [applicantCount: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { applicantCount: args }
    }

    if (Array.isArray(args)) {
        args = {
            applicantCount: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        applicantCount: args.applicantCount,
    }

    return downloadBlankSelfDisclosureTemplate.definition.url
            .replace('{applicantCount}', parsedArgs.applicantCount.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PdfExportController::downloadBlankSelfDisclosureTemplate
* @see app/Http/Controllers/PdfExportController.php:27
* @route '//admin.finesthub.test/templates/self-disclosure/{applicantCount}'
*/
downloadBlankSelfDisclosureTemplate.get = (args: { applicantCount: string | number } | [applicantCount: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: downloadBlankSelfDisclosureTemplate.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PdfExportController::downloadBlankSelfDisclosureTemplate
* @see app/Http/Controllers/PdfExportController.php:27
* @route '//admin.finesthub.test/templates/self-disclosure/{applicantCount}'
*/
downloadBlankSelfDisclosureTemplate.head = (args: { applicantCount: string | number } | [applicantCount: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: downloadBlankSelfDisclosureTemplate.url(args, options),
    method: 'head',
})

const PdfExportController = { generatePdf, previewPdf, generateTemplate, generateBlankSelfDisclosureTemplate, downloadBlankSelfDisclosureTemplate }

export default PdfExportController